import { useEffect, useState } from "react";
import { getDocumentContent } from "./requests";

export const useDocumentContent = (documentVersionId: number) => {
  const [data, setData] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getDocumentContent(documentVersionId);
        setData(data);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchData();
  }, [documentVersionId]);

  return { data, isLoading };
};
